(function (angular) {
  "use strict";

  angular.module('myApp').component("textboxContact", {
    templateUrl: '/core/components/textbox-contact/textbox-contact.tpl.html',
    transclude: true,
    bindings: {
      name: '@',
      label: '@?',
      placeholder: '@',
      type: '@',
      maxlength: '@',
      service: '=',
      required: '@',
      changed: '&',
      disabledIf: '<?',
      isLabelHide: '<?',
    },
    controller: ['$scope', '$timeout', '$http',
      function ($scope, $timeout, $http) {
        
       
        setTimeout(function () {
          var input = document.querySelector("#contactNo");
          console.log(input);
          window.intlTelInput(input, {
            llowExtensions: true,
            formatOnDisplay: true,
            autoFormat: true,
            autoHideDialCode: true,
            autoPlaceholder: true,
            defaultCountry: "auto",
            ipinfoToken: "yolo",

            nationalMode: false,
            numberType: "MOBILE",
            preventInvalidNumbers: true,
            separateDialCode: true,
            utilsScript: "assets/js/utils.js",
          });

        }, 200);
      }
    ],
  });

}(window.angular));
